/**
 * @generated SignedSource<<ecc5d7624a9455c6f99b32a9dd3c5387>>
 * @relayHash 2160bae9d990bef0424cf6790fd9bb6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea5c5b7e6b6b1e0cd31820216482408491694394fecec525769b007f9686cd0a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FormEditQuery } from './FormEditQuery.graphql';

const node: PreloadableConcreteRequest<FormEditQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ea5c5b7e6b6b1e0cd31820216482408491694394fecec525769b007f9686cd0a",
    "metadata": {},
    "name": "FormEditQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
